<script lang="ts">
	import { createTextEditorActions } from './textEditorActions'
	import { _ } from '@repo/i18n'
	import type { Editor } from '@tiptap/core'

	interface Props {
		editor: Editor
	}

	let { editor }: Props = $props()
</script>

<div class="flex flex-wrap gap-2">
	{#each Object.entries(createTextEditorActions($_)) as [_group, buttons] (_group)}
		<div class="group">
			<div class="flex gap-1">
				{#each buttons as { icon: IconComponent, label, action, isActive } (label)}
					<button
						class="flex h-7 w-7 items-center justify-center rounded text-black dark:text-white {isActive(
							editor,
						)
							? 'bg-primary-500 hover:bg-primary-400 text-white'
							: 'hover:bg-gray-100 dark:hover:bg-gray-700'}"
						aria-label={label}
						onclick={() => action(editor)}
						title={label}
						type="button"
					>
						<IconComponent />
					</button>
				{/each}
			</div>
		</div>
	{/each}
</div>
